<div class="page_title">
    <div class="row marges">
        <div class="col y_items_center">
            <h1 class="title">{{ 'payment.title.value' | translate }}</h1>
        </div>

    </div>
</div>

<div *ngIf="isSuccess">

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="form_paymment_reponse">
                <p class="title success">{{ 'subscription.success.title.value' | translate }}</p>
                <p *ngIf="paymentId">{{ 'subscription.success.ref.value' | translate }} : <strong>{{ paymentId }}</strong></p>
                <p>{{ 'subscription.success.email.value' | translate }}</p>
            </div>
        </div>
    </div>

    <div class="row marges ligne_form" *ngIf="paymentId">
        <div class="col_12">
            <div class="form_paymment_reponse">
                <p>{{'subscription.success.card.value' | translate}}</p>
            </div>
        </div>
    </div>

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="form_paymment_reponse">
                <p><strong>{{ 'subscription.success.cgv.value' | translate }}</strong></p>
                <button class="btn_cta btn_little" type="button" (click)="goToCgv()">{{ 'subscription.success.cgv.btn.value' | translate }}</button>
            </div>
        </div>
    </div>

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="form_paymment_reponse">
                <p><strong>{{ 'subscription.success.thanks.value' | translate }}</strong></p>
            </div>
        </div>
    </div>

</div>
<div *ngIf="!isSuccess">

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="form_paymment_reponse">
                <p class="title error">{{ 'subscription.error.title.value' | translate }}</p>
                <p>{{ 'subscription.error.content.value' | translate }}</p>
                <button class="btn_cta btn_little" type="button" (click)="goToSubscriptions()">{{ 'subscription.error.return.value' | translate }}</button>
            </div>
        </div>
    </div>

</div>

